<!-- Fixed-size, no-wrap group to avoid column growth -->
<div
  *ngIf="hasTourAnchor; else actionButtonsWithoutTour"
  [tourAnchor]="tourAnchorId"
  class="ab-wrap"
  aria-label="Acciones de fila">
  <ng-container *ngTemplateOutlet="actionButtonsContent"></ng-container>
</div>

<ng-template #actionButtonsWithoutTour>
  <div class="ab-wrap" aria-label="Acciones de fila">
    <ng-container *ngTemplateOutlet="actionButtonsContent"></ng-container>
  </div>
</ng-template>

<ng-template #actionButtonsContent>
  <!-- INFO -->
  <div class="ab-slot" *ngIf="showInfo">
    <button
      type="button"
      class="ab-btn ab-info"
      pTooltip="Más información"
      tooltipPosition="top"
      (click)="showRowButtonEvent.emit()"
      aria-label="Más información"
    >
      <i class="fa fa-info"></i>
    </button>

    <!-- Tiny badge does not push layout -->
    <span
      *ngIf="showBadge"
      class="ab-badge"
      [class.ab-badge--danger]="notificationSeverity === 'danger'"
      [class.ab-badge--info]="notificationSeverity === 'info'"
      [class.ab-badge--primary]="notificationSeverity === 'primary'"
      >{{ badgeText }}</span
    >
  </div>

  <!-- EDIT -->
  <div class="ab-slot" *ngIf="canEdit">
    <button
      type="button"
      class="ab-btn ab-edit"
      pTooltip="Editar"
      tooltipPosition="top"
      (click)="editRowButtonEvent.emit()"
      aria-label="Editar"
    >
      <i class="fa fa-pencil"></i>
    </button>
  </div>

  <!-- DELETE -->
  <div class="ab-slot" *ngIf="canDelete">
    <button
      type="button"
      class="ab-btn ab-delete"
      pTooltip="Eliminar"
      tooltipPosition="top"
      (click)="deleteRowButtonEvent.emit()"
      aria-label="Eliminar"
    >
      <i class="fa fa-times"></i>
    </button>
  </div>

  <!-- DUPLICATE -->
  <div class="ab-slot" *ngIf="canDuplicate">
    <button
      type="button"
      class="ab-btn ab-duplicate"
      pTooltip="Duplicar"
      tooltipPosition="top"
      (click)="duplicateRowButtonEvent.emit()"
      aria-label="Duplicar"
    >
      <i class="fa fa-copy"></i>
    </button>
  </div>
</ng-template>
